import { Controller } from "stimulus"

export default class extends Controller {
    static values = {
        demandDetailId: String,
        renderUrl: String,
        renderErrorUrl: String,
    }

    static targets = [
        'list'
    ]

    connect() {
        this.render()
    }

    render() {
        fetch(this.renderUrlValue, {
            method: 'POST',
            body: JSON.stringify({ demand_detail_id: this.demandDetailIdValue }),
            headers: {
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if (!res.ok) throw new Error(`Unexpected status ${res.status}`)
            return res.text()
        }).then(value => {
            this.listTarget.innerHTML = value
        }).catch(() => {
            this.renderError()
        })
    }

    renderError() {
        fetch(this.renderErrorUrlValue).then(res => res.text()).then(value => {
            this.listTarget.innerHTML = value
        })
    }
}
